/**
 * Time Formatting Utility
 * Provides conditional time formatting based on notification age
 */

import { format, formatDistanceToNow } from "date-fns"

/**
 * Formats a timestamp for notifications
 * - Less than 5 hours ago: Shows relative time (e.g., "2 hours ago")
 * - 5 hours or more: Shows full date format (e.g., "Nov 25, 2025 at 09:10 PM")
 */
export function formatNotificationTime(date: Date | string): string {
  const notificationDate = new Date(date)
  const now = new Date()
  const hoursDiff = (now.getTime() - notificationDate.getTime()) / (1000 * 60 * 60)

  if (hoursDiff < 5) {
    return formatDistanceToNow(notificationDate, { addSuffix: true })
  }

  return format(notificationDate, "MMM d, yyyy 'at' hh:mm a")
}
